import { TDispatch } from '../type';
import { TShareFreight, TTruckerShareFreight } from './shareFreights.type';

export const ShareFreightsReducer = (state: TShareFreight, { type, payload }: TDispatch): TShareFreight => {
  const removeTrucker = (payloadData: TTruckerShareFreight) => {
    const index = state.truckers.findIndex((trucker) => trucker.uuid === payloadData.uuid);

    const tempState = [...state.truckers];

    tempState.splice(index, 1);

    return tempState;
  };

  switch (type) {
    case 'set_selected_trucker':
      return {
        ...state,
        truckers: [...state.truckers, payload as TTruckerShareFreight],
      };
    case 'remove_selected_trucker':
      return {
        ...state,
        truckers: removeTrucker(payload as TTruckerShareFreight),
      };
    case 'set_all_selected_truckers':
      return {
        ...state,
        truckers: payload as TShareFreight['truckers'],
      };
    case 'remove_all_selected_truckers':
      return {
        ...state,
        truckers: [],
      };
    case 'toggle_modal_share_freight':
      return {
        ...state,
        isOpenModalShareFreight: !state.isOpenModalShareFreight,
      };

    default:
      return state;
  }
};

ShareFreightsReducer.key = 'shareFreights';
ShareFreightsReducer.initialState = {
  truckers: [],
  isOpenModalShareFreight: false,
};

export default { ShareFreightsReducer };
